module.exports = __webpack_public_path__ + "34015d7b72d7714338d82d32eeab6044.pdf";